(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("styled-components"));else if (typeof define === 'function' && define.amd) define(["react", "styled-components"], factory);else if (typeof exports === 'object') exports["react-typed"] = factory(require("react"), require("styled-components"));else root["react-typed"] = factory(root["React"], root[undefined]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_12__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "/";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 4);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       */

      function makeEmptyFunction(arg) {
        return function () {
          return arg;
        };
      }
      /**
       * This function accepts and discards inputs; it has no side effects. This is
       * primarily useful idiomatically for overridable function endpoints which
       * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
       */


      var emptyFunction = function emptyFunction() {};

      emptyFunction.thatReturns = makeEmptyFunction;
      emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
      emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
      emptyFunction.thatReturnsNull = makeEmptyFunction(null);

      emptyFunction.thatReturnsThis = function () {
        return this;
      };

      emptyFunction.thatReturnsArgument = function (arg) {
        return arg;
      };

      module.exports = emptyFunction;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      /**
       * Use invariant() to assert state which your program assumes to be true.
       *
       * Provide sprintf-style format (only %s is supported) and arguments
       * to provide information about what broke and what you were
       * expecting.
       *
       * The invariant message will be stripped in production, but the invariant
       * will remain to ensure logic does not differ in production.
       */

      var validateFormat = function validateFormat(format) {};

      if (undefined !== 'production') {
        validateFormat = function validateFormat(format) {
          if (format === undefined) {
            throw new Error('invariant requires an error message argument');
          }
        };
      }

      function invariant(condition, format, a, b, c, d, e, f) {
        validateFormat(format);

        if (!condition) {
          var error;

          if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
          } else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
              return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
          }

          error.framesToPop = 1; // we don't care about invariant's own frame

          throw error;
        }
      }

      module.exports = invariant;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
      module.exports = ReactPropTypesSecret;
      /***/
    },
    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var emptyFunction = __webpack_require__(0);
      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var warning = emptyFunction;

      if (undefined !== 'production') {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.error(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        warning = function warning(condition, format) {
          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (format.indexOf('Failed Composite propType: ') === 0) {
            return; // Ignore CompositeComponent proptype check.
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }

      module.exports = warning;
      /***/
    },
    /* 4 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _templateObject = _taggedTemplateLiteral(['\n    .typed-cursor{\n        opacity: 1;\n        animation: typedjsBlink 0.7s infinite;\n        -webkit-animation: typedjsBlink 0.7s infinite;\n        animation: typedjsBlink 0.7s infinite;\n    }\n    @keyframes typedjsBlink{\n        50% { opacity: 0.0; }\n    }\n    @-webkit-keyframes typedjsBlink{\n        0% { opacity: 1; }\n        50% { opacity: 0.0;}\n        100% { opacity: 1; }\n    }\n    .typed-fade-out{\n        opacity: 0;\n        transition: opacity .25s;\n        -webkit-animation: 0;\n        animation: 0;\n    }\n'], ['\n    .typed-cursor{\n        opacity: 1;\n        animation: typedjsBlink 0.7s infinite;\n        -webkit-animation: typedjsBlink 0.7s infinite;\n        animation: typedjsBlink 0.7s infinite;\n    }\n    @keyframes typedjsBlink{\n        50% { opacity: 0.0; }\n    }\n    @-webkit-keyframes typedjsBlink{\n        0% { opacity: 1; }\n        50% { opacity: 0.0;}\n        100% { opacity: 1; }\n    }\n    .typed-fade-out{\n        opacity: 0;\n        transition: opacity .25s;\n        -webkit-animation: 0;\n        animation: 0;\n    }\n']);

      var _react = __webpack_require__(5);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(6);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _typed = __webpack_require__(11);

      var _typed2 = _interopRequireDefault(_typed);

      var _styledComponents = __webpack_require__(12);

      var _styledComponents2 = _interopRequireDefault(_styledComponents);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function _taggedTemplateLiteral(strings, raw) {
        return Object.freeze(Object.defineProperties(strings, {
          raw: {
            value: Object.freeze(raw)
          }
        }));
      }

      var TypedWrapper = _styledComponents2.default.span(_templateObject);

      var ReactTyped = function (_Component) {
        _inherits(ReactTyped, _Component);

        function ReactTyped() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, ReactTyped);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactTyped.__proto__ || Object.getPrototypeOf(ReactTyped)).call.apply(_ref, [this].concat(args))), _this), _this.rootElement = _react2.default.createRef(), _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(ReactTyped, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _props = this.props,
                style = _props.style,
                typedRef = _props.typedRef,
                stopped = _props.stopped,
                className = _props.className,
                typedOptions = _objectWithoutProperties(_props, ['style', 'typedRef', 'stopped', 'className']);

            this.constructTyped(typedOptions);

            if (stopped) {
              this.typed.stop();
            }
          }
        }, {
          key: 'constructTyped',
          value: function constructTyped() {
            var _this2 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var _props2 = this.props,
                style = _props2.style,
                typedRef = _props2.typedRef,
                stopped = _props2.stopped,
                className = _props2.className,
                typedOptions = _objectWithoutProperties(_props2, ['style', 'typedRef', 'stopped', 'className']);

            if (this.typed) {
              this.typed.destroy();
            }

            this.typed = new _typed2.default(this.rootElement.current, Object.assign(typedOptions, options));

            if (this.props.typedRef) {
              this.props.typedRef(this.typed);
            }

            this.typed.reConstruct = function (opts) {
              _this2.constructTyped(opts);
            };
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (this.props !== nextProps) {
              var style = nextProps.style,
                  typedRef = nextProps.typedRef,
                  stopped = nextProps.stopped,
                  className = nextProps.className,
                  typedOptions = _objectWithoutProperties(nextProps, ['style', 'typedRef', 'stopped', 'className']);

              this.typed.options = Object.assign(this.typed.options, typedOptions);
              var reConstructed = !Object.keys(nextProps).every(function (key) {
                if (!_this3.props[key] && nextProps[key]) {
                  _this3.constructTyped(nextProps);

                  return false;
                }

                if (_this3.typed[key]) {
                  _this3.typed[key] = nextProps[key];
                }

                return true;
              });

              if (!reConstructed && this.props.strings.length !== nextProps.strings.length) {
                this.constructTyped(nextProps);
              }

              return true;
            }

            return false;
          }
        }, {
          key: 'render',
          value: function render() {
            var _props3 = this.props,
                style = _props3.style,
                className = _props3.className,
                children = _props3.children;

            var child = _react2.default.createElement('span', {
              ref: this.rootElement
            });

            if (children) {
              child = _react2.default.cloneElement(children, {
                ref: this.rootElement
              });
            }

            return _react2.default.createElement(TypedWrapper, {
              style: style,
              className: className
            }, child);
          }
        }]);

        return ReactTyped;
      }(_react.Component);

      ReactTyped.propTypes = {
        /** styles for the outer element */
        style: _propTypes2.default.object,

        /** class name for the outer element */
        className: _propTypes2.default.string,

        /** the element to wrapp */
        children: _propTypes2.default.object,

        /** typedRef(self: Typed) returns the Typed instance */
        typedRef: _propTypes2.default.func,

        /** initialize in stopped state */
        stopped: _propTypes2.default.bool,

        /** strings to be typed */
        strings: _propTypes2.default.arrayOf(_propTypes2.default.string),

        /**  type speed in milliseconds */
        typeSpeed: _propTypes2.default.number,

        /** time before typing starts in milliseconds */
        startDelay: _propTypes2.default.number,

        /** backspacing speed in milliseconds */
        backSpeed: _propTypes2.default.number,

        /**  only backspace what doesn't match the previous string */
        smartBackspace: _propTypes2.default.bool,

        /** shuffle the strings */
        shuffle: _propTypes2.default.bool,

        /** time before backspacing in milliseconds */
        backDelay: _propTypes2.default.number,

        /** Fade out instead of backspace */
        fadeOut: _propTypes2.default.bool,

        /** css class for fade animation */
        fadeOutClass: _propTypes2.default.string,

        /** Fade out delay in milliseconds */
        fadeOutDelay: _propTypes2.default.number,

        /** loop the strings */
        loop: _propTypes2.default.bool,

        /** amount of loops */
        loopCount: _propTypes2.default.number,

        /** show cursor */
        showCursor: _propTypes2.default.bool,

        /** character for cursor */
        cursorChar: _propTypes2.default.string,

        /** insert CSS for cursor and fadeOut into HTML */
        autoInsertCss: _propTypes2.default.bool,

        /** attribute for typing Ex: input placeholder, value, or just HTML text */
        attr: _propTypes2.default.string,

        /**  bind to focus and blur if el is text input */
        bindInputFocusEvents: _propTypes2.default.bool,

        /**  'html' or 'null' for plaintext */
        contentType: _propTypes2.default.oneOf(['html', '']),

        /** onComplete(self: Typed) All typing is complete */
        onComplete: _propTypes2.default.func,

        /** preStringTyped(arrayPos: number, self: Typed) Before each string is typed */
        preStringTyped: _propTypes2.default.func,

        /** onStringTyped(arrayPos: number, self: Typed) After each string is typed */
        onStringTyped: _propTypes2.default.func,

        /** onLastStringBackspaced(self: Typed) During looping, after last string is typed */
        onLastStringBackspaced: _propTypes2.default.func,

        /** onTypingPaused(arrayPos: number, self: Typed) Typing has been stopped */
        onTypingPaused: _propTypes2.default.func,

        /** onTypingResumed(arrayPos: number, self: Typed) Typing has been started after being stopped */
        onTypingResumed: _propTypes2.default.func,

        /** onReset(self: Typed) After reset */
        onReset: _propTypes2.default.func,

        /** onStop(arrayPos: number, self: Typed)    After stop */
        onStop: _propTypes2.default.func,

        /** onStart(arrayPos: number, self: Typed) After start */
        onStart: _propTypes2.default.func,

        /** onDestroy(self: Typed) After destroy */
        onDestroy: _propTypes2.default.func
      };
      exports.default = ReactTyped;
      /***/
    },
    /* 5 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
      /***/
    },
    /* 6 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      if (undefined !== 'production') {
        var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

        var isValidElement = function isValidElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }; // By explicitly using `prop-types` you are opting into new development behavior.
        // http://fb.me/prop-types-in-prod


        var throwOnDirectAccess = true;
        module.exports = __webpack_require__(7)(isValidElement, throwOnDirectAccess);
      } else {
        // By explicitly using `prop-types` you are opting into new production behavior.
        // http://fb.me/prop-types-in-prod
        module.exports = __webpack_require__(10)();
      }
      /***/

    },
    /* 7 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var emptyFunction = __webpack_require__(0);

      var invariant = __webpack_require__(1);

      var warning = __webpack_require__(3);

      var assign = __webpack_require__(8);

      var ReactPropTypesSecret = __webpack_require__(2);

      var checkPropTypes = __webpack_require__(9);

      module.exports = function (isValidElement, throwOnDirectAccess) {
        /* global Symbol */
        var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

        /**
         * Returns the iterator method function contained on the iterable object.
         *
         * Be sure to invoke the function with the iterable as context:
         *
         *     var iteratorFn = getIteratorFn(myIterable);
         *     if (iteratorFn) {
         *       var iterator = iteratorFn.call(myIterable);
         *       ...
         *     }
         *
         * @param {?object} maybeIterable
         * @return {?function}
         */

        function getIteratorFn(maybeIterable) {
          var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

          if (typeof iteratorFn === 'function') {
            return iteratorFn;
          }
        }
        /**
         * Collection of methods that allow declaration and validation of props that are
         * supplied to React components. Example usage:
         *
         *   var Props = require('ReactPropTypes');
         *   var MyArticle = React.createClass({
         *     propTypes: {
         *       // An optional string prop named "description".
         *       description: Props.string,
         *
         *       // A required enum prop named "category".
         *       category: Props.oneOf(['News','Photos']).isRequired,
         *
         *       // A prop named "dialog" that requires an instance of Dialog.
         *       dialog: Props.instanceOf(Dialog).isRequired
         *     },
         *     render: function() { ... }
         *   });
         *
         * A more formal specification of how these methods are used:
         *
         *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
         *   decl := ReactPropTypes.{type}(.isRequired)?
         *
         * Each and every declaration produces a function with the same signature. This
         * allows the creation of custom validation functions. For example:
         *
         *  var MyLink = React.createClass({
         *    propTypes: {
         *      // An optional string or URI prop named "href".
         *      href: function(props, propName, componentName) {
         *        var propValue = props[propName];
         *        if (propValue != null && typeof propValue !== 'string' &&
         *            !(propValue instanceof URI)) {
         *          return new Error(
         *            'Expected a string or an URI for ' + propName + ' in ' +
         *            componentName
         *          );
         *        }
         *      }
         *    },
         *    render: function() {...}
         *  });
         *
         * @internal
         */


        var ANONYMOUS = '<<anonymous>>'; // Important!
        // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

        var ReactPropTypes = {
          array: createPrimitiveTypeChecker('array'),
          bool: createPrimitiveTypeChecker('boolean'),
          func: createPrimitiveTypeChecker('function'),
          number: createPrimitiveTypeChecker('number'),
          object: createPrimitiveTypeChecker('object'),
          string: createPrimitiveTypeChecker('string'),
          symbol: createPrimitiveTypeChecker('symbol'),
          any: createAnyTypeChecker(),
          arrayOf: createArrayOfTypeChecker,
          element: createElementTypeChecker(),
          instanceOf: createInstanceTypeChecker,
          node: createNodeChecker(),
          objectOf: createObjectOfTypeChecker,
          oneOf: createEnumTypeChecker,
          oneOfType: createUnionTypeChecker,
          shape: createShapeTypeChecker,
          exact: createStrictShapeTypeChecker
        };
        /**
         * inlined Object.is polyfill to avoid requiring consumers ship their own
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
         */

        /*eslint-disable no-self-compare*/

        function is(x, y) {
          // SameValue algorithm
          if (x === y) {
            // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            return x !== 0 || 1 / x === 1 / y;
          } else {
            // Step 6.a: NaN == NaN
            return x !== x && y !== y;
          }
        }
        /*eslint-enable no-self-compare*/

        /**
         * We use an Error-like object for backward compatibility as people may call
         * PropTypes directly and inspect their output. However, we don't use real
         * Errors anymore. We don't inspect their stack anyway, and creating them
         * is prohibitively expensive if they are created too often, such as what
         * happens in oneOfType() for any type before the one that matched.
         */


        function PropTypeError(message) {
          this.message = message;
          this.stack = '';
        } // Make `instanceof Error` still work for returned errors.


        PropTypeError.prototype = Error.prototype;

        function createChainableTypeChecker(validate) {
          if (undefined !== 'production') {
            var manualPropTypeCallCache = {};
            var manualPropTypeWarningCount = 0;
          }

          function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;

            if (secret !== ReactPropTypesSecret) {
              if (throwOnDirectAccess) {
                // New behavior only for users of `prop-types` package
                invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
              } else if (undefined !== 'production' && typeof console !== 'undefined') {
                // Old behavior for people using React.PropTypes
                var cacheKey = componentName + ':' + propName;

                if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                manualPropTypeWarningCount < 3) {
                  warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName);
                  manualPropTypeCallCache[cacheKey] = true;
                  manualPropTypeWarningCount++;
                }
              }
            }

            if (props[propName] == null) {
              if (isRequired) {
                if (props[propName] === null) {
                  return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                }

                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
              }

              return null;
            } else {
              return validate(props, propName, componentName, location, propFullName);
            }
          }

          var chainedCheckType = checkType.bind(null, false);
          chainedCheckType.isRequired = checkType.bind(null, true);
          return chainedCheckType;
        }

        function createPrimitiveTypeChecker(expectedType) {
          function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);

            if (propType !== expectedType) {
              // `propValue` being instance of, say, date/regexp, pass the 'object'
              // check, but we can offer a more precise error message here rather than
              // 'of type `object`'.
              var preciseType = getPreciseType(propValue);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createAnyTypeChecker() {
          return createChainableTypeChecker(emptyFunction.thatReturnsNull);
        }

        function createArrayOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') {
              return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            }

            var propValue = props[propName];

            if (!Array.isArray(propValue)) {
              var propType = getPropType(propValue);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }

            for (var i = 0; i < propValue.length; i++) {
              var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createElementTypeChecker() {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];

            if (!isValidElement(propValue)) {
              var propType = getPropType(propValue);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createInstanceTypeChecker(expectedClass) {
          function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
              var expectedClassName = expectedClass.name || ANONYMOUS;
              var actualClassName = getClassName(props[propName]);
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createEnumTypeChecker(expectedValues) {
          if (!Array.isArray(expectedValues)) {
            undefined !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
            return emptyFunction.thatReturnsNull;
          }

          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];

            for (var i = 0; i < expectedValues.length; i++) {
              if (is(propValue, expectedValues[i])) {
                return null;
              }
            }

            var valuesString = JSON.stringify(expectedValues);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
          }

          return createChainableTypeChecker(validate);
        }

        function createObjectOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') {
              return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            }

            var propValue = props[propName];
            var propType = getPropType(propValue);

            if (propType !== 'object') {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            }

            for (var key in propValue) {
              if (propValue.hasOwnProperty(key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                if (error instanceof Error) {
                  return error;
                }
              }
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createUnionTypeChecker(arrayOfTypeCheckers) {
          if (!Array.isArray(arrayOfTypeCheckers)) {
            undefined !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
            return emptyFunction.thatReturnsNull;
          }

          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (typeof checker !== 'function') {
              warning(false, 'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received %s at index %s.', getPostfixForTypeWarning(checker), i);
              return emptyFunction.thatReturnsNull;
            }
          }

          function validate(props, propName, componentName, location, propFullName) {
            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];

              if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                return null;
              }
            }

            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
          }

          return createChainableTypeChecker(validate);
        }

        function createNodeChecker() {
          function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);

            if (propType !== 'object') {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            }

            for (var key in shapeTypes) {
              var checker = shapeTypes[key];

              if (!checker) {
                continue;
              }

              var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error) {
                return error;
              }
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createStrictShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);

            if (propType !== 'object') {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            } // We need to check all keys in case some are required but missing from
            // props.


            var allKeys = assign({}, props[propName], shapeTypes);

            for (var key in allKeys) {
              var checker = shapeTypes[key];

              if (!checker) {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
              }

              var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error) {
                return error;
              }
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function isNode(propValue) {
          switch (typeof propValue) {
            case 'number':
            case 'string':
            case 'undefined':
              return true;

            case 'boolean':
              return !propValue;

            case 'object':
              if (Array.isArray(propValue)) {
                return propValue.every(isNode);
              }

              if (propValue === null || isValidElement(propValue)) {
                return true;
              }

              var iteratorFn = getIteratorFn(propValue);

              if (iteratorFn) {
                var iterator = iteratorFn.call(propValue);
                var step;

                if (iteratorFn !== propValue.entries) {
                  while (!(step = iterator.next()).done) {
                    if (!isNode(step.value)) {
                      return false;
                    }
                  }
                } else {
                  // Iterator will provide entry [k,v] tuples rather than values.
                  while (!(step = iterator.next()).done) {
                    var entry = step.value;

                    if (entry) {
                      if (!isNode(entry[1])) {
                        return false;
                      }
                    }
                  }
                }
              } else {
                return false;
              }

              return true;

            default:
              return false;
          }
        }

        function isSymbol(propType, propValue) {
          // Native Symbol.
          if (propType === 'symbol') {
            return true;
          } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


          if (propValue['@@toStringTag'] === 'Symbol') {
            return true;
          } // Fallback for non-spec compliant Symbols which are polyfilled.


          if (typeof Symbol === 'function' && propValue instanceof Symbol) {
            return true;
          }

          return false;
        } // Equivalent of `typeof` but with special handling for array and regexp.


        function getPropType(propValue) {
          var propType = typeof propValue;

          if (Array.isArray(propValue)) {
            return 'array';
          }

          if (propValue instanceof RegExp) {
            // Old webkits (at least until Android 4.0) return 'function' rather than
            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
            // passes PropTypes.object.
            return 'object';
          }

          if (isSymbol(propType, propValue)) {
            return 'symbol';
          }

          return propType;
        } // This handles more types than `getPropType`. Only used for error messages.
        // See `createPrimitiveTypeChecker`.


        function getPreciseType(propValue) {
          if (typeof propValue === 'undefined' || propValue === null) {
            return '' + propValue;
          }

          var propType = getPropType(propValue);

          if (propType === 'object') {
            if (propValue instanceof Date) {
              return 'date';
            } else if (propValue instanceof RegExp) {
              return 'regexp';
            }
          }

          return propType;
        } // Returns a string that is postfixed to a warning about an invalid type.
        // For example, "undefined" or "of type array"


        function getPostfixForTypeWarning(value) {
          var type = getPreciseType(value);

          switch (type) {
            case 'array':
            case 'object':
              return 'an ' + type;

            case 'boolean':
            case 'date':
            case 'regexp':
              return 'a ' + type;

            default:
              return type;
          }
        } // Returns class name of the object, if any.


        function getClassName(propValue) {
          if (!propValue.constructor || !propValue.constructor.name) {
            return ANONYMOUS;
          }

          return propValue.constructor.name;
        }

        ReactPropTypes.checkPropTypes = checkPropTypes;
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
      };
      /***/

    },
    /* 8 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */

      /* eslint-disable no-unused-vars */

      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;

      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
      }

      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          } // Detect buggy property enumeration order in older V8 versions.
          // https://bugs.chromium.org/p/v8/issues/detail?id=4118


          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

          test1[5] = 'de';

          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


          var test2 = {};

          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }

          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });

          if (order2.join('') !== '0123456789') {
            return false;
          } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });

          if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
            return false;
          }

          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }

      module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;

        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);

          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }

          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);

            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }

        return to;
      };
      /***/
    },
    /* 9 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      if (undefined !== 'production') {
        var invariant = __webpack_require__(1);

        var warning = __webpack_require__(3);

        var ReactPropTypesSecret = __webpack_require__(2);

        var loggedTypeFailures = {};
      }
      /**
       * Assert that the values match with the type specs.
       * Error messages are memorized and will only be shown once.
       *
       * @param {object} typeSpecs Map of name to a ReactPropType
       * @param {object} values Runtime values that need to be type-checked
       * @param {string} location e.g. "prop", "context", "child context"
       * @param {string} componentName Name of the component for error messages.
       * @param {?Function} getStack Returns the component stack.
       * @private
       */


      function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
        if (undefined !== 'production') {
          for (var typeSpecName in typeSpecs) {
            if (typeSpecs.hasOwnProperty(typeSpecName)) {
              var error; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
                error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
              } catch (ex) {
                error = ex;
              }

              warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);

              if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error.message] = true;
                var stack = getStack ? getStack() : '';
                warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
              }
            }
          }
        }
      }

      module.exports = checkPropTypes;
      /***/
    },
    /* 10 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var emptyFunction = __webpack_require__(0);

      var invariant = __webpack_require__(1);

      var ReactPropTypesSecret = __webpack_require__(2);

      module.exports = function () {
        function shim(props, propName, componentName, location, propFullName, secret) {
          if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
          }

          invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
        }

        ;
        shim.isRequired = shim;

        function getShim() {
          return shim;
        }

        ; // Important!
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

        var ReactPropTypes = {
          array: shim,
          bool: shim,
          func: shim,
          number: shim,
          object: shim,
          string: shim,
          symbol: shim,
          any: shim,
          arrayOf: getShim,
          element: shim,
          instanceOf: getShim,
          node: shim,
          objectOf: getShim,
          oneOf: getShim,
          oneOfType: getShim,
          shape: getShim,
          exact: getShim
        };
        ReactPropTypes.checkPropTypes = emptyFunction;
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
      };
      /***/

    },
    /* 11 */

    /***/
    function (module, exports, __webpack_require__) {
      /*!
       * 
       *   typed.js - A JavaScript Typing Animation Library
       *   Author: Matt Boldt <me@mattboldt.com>
       *   Version: v2.0.6
       *   Url: https://github.com/mattboldt/typed.js
       *   License(s): MIT
       * 
       */
      (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["Typed"] = factory();else root["Typed"] = factory();
      })(this, function () {
        return (
          /******/
          function (modules) {
            // webpackBootstrap

            /******/
            // The module cache

            /******/
            var installedModules = {};
            /******/

            /******/
            // The require function

            /******/

            function __webpack_require__(moduleId) {
              /******/

              /******/
              // Check if module is in cache

              /******/
              if (installedModules[moduleId])
                /******/
                return installedModules[moduleId].exports;
              /******/

              /******/
              // Create a new module (and put it into the cache)

              /******/

              var module = installedModules[moduleId] = {
                /******/
                exports: {},

                /******/
                id: moduleId,

                /******/
                loaded: false
                /******/

              };
              /******/

              /******/
              // Execute the module function

              /******/

              modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
              /******/

              /******/
              // Flag the module as loaded

              /******/

              module.loaded = true;
              /******/

              /******/
              // Return the exports of the module

              /******/

              return module.exports;
              /******/
            }
            /******/

            /******/

            /******/
            // expose the modules object (__webpack_modules__)

            /******/


            __webpack_require__.m = modules;
            /******/

            /******/
            // expose the module cache

            /******/

            __webpack_require__.c = installedModules;
            /******/

            /******/
            // __webpack_public_path__

            /******/

            __webpack_require__.p = "";
            /******/

            /******/
            // Load entry module and return exports

            /******/

            return __webpack_require__(0);
            /******/
          }(
          /************************************************************************/

          /******/
          [
          /* 0 */

          /***/
          function (module, exports, __webpack_require__) {
            'use strict';

            Object.defineProperty(exports, '__esModule', {
              value: true
            });

            var _createClass = function () {
              function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ('value' in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }

              return function (Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
              };
            }();

            function _classCallCheck(instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
              }
            }

            var _initializerJs = __webpack_require__(1);

            var _htmlParserJs = __webpack_require__(3);
            /**
             * Welcome to Typed.js!
             * @param {string} elementId HTML element ID _OR_ HTML element
             * @param {object} options options object
             * @returns {object} a new Typed object
             */


            var Typed = function () {
              function Typed(elementId, options) {
                _classCallCheck(this, Typed); // Initialize it up


                _initializerJs.initializer.load(this, options, elementId); // All systems go!


                this.begin();
              }
              /**
               * Toggle start() and stop() of the Typed instance
               * @public
               */


              _createClass(Typed, [{
                key: 'toggle',
                value: function toggle() {
                  this.pause.status ? this.start() : this.stop();
                }
                /**
                 * Stop typing / backspacing and enable cursor blinking
                 * @public
                 */

              }, {
                key: 'stop',
                value: function stop() {
                  if (this.typingComplete) return;
                  if (this.pause.status) return;
                  this.toggleBlinking(true);
                  this.pause.status = true;
                  this.options.onStop(this.arrayPos, this);
                }
                /**
                 * Start typing / backspacing after being stopped
                 * @public
                 */

              }, {
                key: 'start',
                value: function start() {
                  if (this.typingComplete) return;
                  if (!this.pause.status) return;
                  this.pause.status = false;

                  if (this.pause.typewrite) {
                    this.typewrite(this.pause.curString, this.pause.curStrPos);
                  } else {
                    this.backspace(this.pause.curString, this.pause.curStrPos);
                  }

                  this.options.onStart(this.arrayPos, this);
                }
                /**
                 * Destroy this instance of Typed
                 * @public
                 */

              }, {
                key: 'destroy',
                value: function destroy() {
                  this.reset(false);
                  this.options.onDestroy(this);
                }
                /**
                 * Reset Typed and optionally restarts
                 * @param {boolean} restart
                 * @public
                 */

              }, {
                key: 'reset',
                value: function reset() {
                  var restart = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
                  clearInterval(this.timeout);
                  this.replaceText('');

                  if (this.cursor && this.cursor.parentNode) {
                    this.cursor.parentNode.removeChild(this.cursor);
                    this.cursor = null;
                  }

                  this.strPos = 0;
                  this.arrayPos = 0;
                  this.curLoop = 0;

                  if (restart) {
                    this.insertCursor();
                    this.options.onReset(this);
                    this.begin();
                  }
                }
                /**
                 * Begins the typing animation
                 * @private
                 */

              }, {
                key: 'begin',
                value: function begin() {
                  var _this = this;

                  this.typingComplete = false;
                  this.shuffleStringsIfNeeded(this);
                  this.insertCursor();
                  if (this.bindInputFocusEvents) this.bindFocusEvents();
                  this.timeout = setTimeout(function () {
                    // Check if there is some text in the element, if yes start by backspacing the default message
                    if (!_this.currentElContent || _this.currentElContent.length === 0) {
                      _this.typewrite(_this.strings[_this.sequence[_this.arrayPos]], _this.strPos);
                    } else {
                      // Start typing
                      _this.backspace(_this.currentElContent, _this.currentElContent.length);
                    }
                  }, this.startDelay);
                }
                /**
                 * Called for each character typed
                 * @param {string} curString the current string in the strings array
                 * @param {number} curStrPos the current position in the curString
                 * @private
                 */

              }, {
                key: 'typewrite',
                value: function typewrite(curString, curStrPos) {
                  var _this2 = this;

                  if (this.fadeOut && this.el.classList.contains(this.fadeOutClass)) {
                    this.el.classList.remove(this.fadeOutClass);
                    if (this.cursor) this.cursor.classList.remove(this.fadeOutClass);
                  }

                  var humanize = this.humanizer(this.typeSpeed);
                  var numChars = 1;

                  if (this.pause.status === true) {
                    this.setPauseStatus(curString, curStrPos, true);
                    return;
                  } // contain typing function in a timeout humanize'd delay


                  this.timeout = setTimeout(function () {
                    // skip over any HTML chars
                    curStrPos = _htmlParserJs.htmlParser.typeHtmlChars(curString, curStrPos, _this2);
                    var pauseTime = 0;
                    var substr = curString.substr(curStrPos); // check for an escape character before a pause value
                    // format: \^\d+ .. eg: ^1000 .. should be able to print the ^ too using ^^
                    // single ^ are removed from string

                    if (substr.charAt(0) === '^') {
                      if (/^\^\d+/.test(substr)) {
                        var skip = 1; // skip at least 1

                        substr = /\d+/.exec(substr)[0];
                        skip += substr.length;
                        pauseTime = parseInt(substr);
                        _this2.temporaryPause = true;

                        _this2.options.onTypingPaused(_this2.arrayPos, _this2); // strip out the escape character and pause value so they're not printed


                        curString = curString.substring(0, curStrPos) + curString.substring(curStrPos + skip);

                        _this2.toggleBlinking(true);
                      }
                    } // check for skip characters formatted as
                    // "this is a `string to print NOW` ..."


                    if (substr.charAt(0) === '`') {
                      while (curString.substr(curStrPos + numChars).charAt(0) !== '`') {
                        numChars++;
                        if (curStrPos + numChars > curString.length) break;
                      } // strip out the escape characters and append all the string in between


                      var stringBeforeSkip = curString.substring(0, curStrPos);
                      var stringSkipped = curString.substring(stringBeforeSkip.length + 1, curStrPos + numChars);
                      var stringAfterSkip = curString.substring(curStrPos + numChars + 1);
                      curString = stringBeforeSkip + stringSkipped + stringAfterSkip;
                      numChars--;
                    } // timeout for any pause after a character


                    _this2.timeout = setTimeout(function () {
                      // Accounts for blinking while paused
                      _this2.toggleBlinking(false); // We're done with this sentence!


                      if (curStrPos === curString.length) {
                        _this2.doneTyping(curString, curStrPos);
                      } else {
                        _this2.keepTyping(curString, curStrPos, numChars);
                      } // end of character pause


                      if (_this2.temporaryPause) {
                        _this2.temporaryPause = false;

                        _this2.options.onTypingResumed(_this2.arrayPos, _this2);
                      }
                    }, pauseTime); // humanized value for typing
                  }, humanize);
                }
                /**
                 * Continue to the next string & begin typing
                 * @param {string} curString the current string in the strings array
                 * @param {number} curStrPos the current position in the curString
                 * @private
                 */

              }, {
                key: 'keepTyping',
                value: function keepTyping(curString, curStrPos, numChars) {
                  // call before functions if applicable
                  if (curStrPos === 0) {
                    this.toggleBlinking(false);
                    this.options.preStringTyped(this.arrayPos, this);
                  } // start typing each new char into existing string
                  // curString: arg, this.el.html: original text inside element


                  curStrPos += numChars;
                  var nextString = curString.substr(0, curStrPos);
                  this.replaceText(nextString); // loop the function

                  this.typewrite(curString, curStrPos);
                }
                /**
                 * We're done typing all strings
                 * @param {string} curString the current string in the strings array
                 * @param {number} curStrPos the current position in the curString
                 * @private
                 */

              }, {
                key: 'doneTyping',
                value: function doneTyping(curString, curStrPos) {
                  var _this3 = this; // fires callback function


                  this.options.onStringTyped(this.arrayPos, this);
                  this.toggleBlinking(true); // is this the final string

                  if (this.arrayPos === this.strings.length - 1) {
                    // callback that occurs on the last typed string
                    this.complete(); // quit if we wont loop back

                    if (this.loop === false || this.curLoop === this.loopCount) {
                      return;
                    }
                  }

                  this.timeout = setTimeout(function () {
                    _this3.backspace(curString, curStrPos);
                  }, this.backDelay);
                }
                /**
                 * Backspaces 1 character at a time
                 * @param {string} curString the current string in the strings array
                 * @param {number} curStrPos the current position in the curString
                 * @private
                 */

              }, {
                key: 'backspace',
                value: function backspace(curString, curStrPos) {
                  var _this4 = this;

                  if (this.pause.status === true) {
                    this.setPauseStatus(curString, curStrPos, true);
                    return;
                  }

                  if (this.fadeOut) return this.initFadeOut();
                  this.toggleBlinking(false);
                  var humanize = this.humanizer(this.backSpeed);
                  this.timeout = setTimeout(function () {
                    curStrPos = _htmlParserJs.htmlParser.backSpaceHtmlChars(curString, curStrPos, _this4); // replace text with base text + typed characters

                    var curStringAtPosition = curString.substr(0, curStrPos);

                    _this4.replaceText(curStringAtPosition); // if smartBack is enabled


                    if (_this4.smartBackspace) {
                      // the remaining part of the current string is equal of the same part of the new string
                      var nextString = _this4.strings[_this4.arrayPos + 1];

                      if (nextString && curStringAtPosition === nextString.substr(0, curStrPos)) {
                        _this4.stopNum = curStrPos;
                      } else {
                        _this4.stopNum = 0;
                      }
                    } // if the number (id of character in current string) is
                    // less than the stop number, keep going


                    if (curStrPos > _this4.stopNum) {
                      // subtract characters one by one
                      curStrPos--; // loop the function

                      _this4.backspace(curString, curStrPos);
                    } else if (curStrPos <= _this4.stopNum) {
                      // if the stop number has been reached, increase
                      // array position to next string
                      _this4.arrayPos++; // When looping, begin at the beginning after backspace complete

                      if (_this4.arrayPos === _this4.strings.length) {
                        _this4.arrayPos = 0;

                        _this4.options.onLastStringBackspaced();

                        _this4.shuffleStringsIfNeeded();

                        _this4.begin();
                      } else {
                        _this4.typewrite(_this4.strings[_this4.sequence[_this4.arrayPos]], curStrPos);
                      }
                    } // humanized value for typing

                  }, humanize);
                }
                /**
                 * Full animation is complete
                 * @private
                 */

              }, {
                key: 'complete',
                value: function complete() {
                  this.options.onComplete(this);

                  if (this.loop) {
                    this.curLoop++;
                  } else {
                    this.typingComplete = true;
                  }
                }
                /**
                 * Has the typing been stopped
                 * @param {string} curString the current string in the strings array
                 * @param {number} curStrPos the current position in the curString
                 * @param {boolean} isTyping
                 * @private
                 */

              }, {
                key: 'setPauseStatus',
                value: function setPauseStatus(curString, curStrPos, isTyping) {
                  this.pause.typewrite = isTyping;
                  this.pause.curString = curString;
                  this.pause.curStrPos = curStrPos;
                }
                /**
                 * Toggle the blinking cursor
                 * @param {boolean} isBlinking
                 * @private
                 */

              }, {
                key: 'toggleBlinking',
                value: function toggleBlinking(isBlinking) {
                  if (!this.cursor) return; // if in paused state, don't toggle blinking a 2nd time

                  if (this.pause.status) return;
                  if (this.cursorBlinking === isBlinking) return;
                  this.cursorBlinking = isBlinking;
                  var status = isBlinking ? 'infinite' : 0;
                  this.cursor.style.animationIterationCount = status;
                }
                /**
                 * Speed in MS to type
                 * @param {number} speed
                 * @private
                 */

              }, {
                key: 'humanizer',
                value: function humanizer(speed) {
                  return Math.round(Math.random() * speed / 2) + speed;
                }
                /**
                 * Shuffle the sequence of the strings array
                 * @private
                 */

              }, {
                key: 'shuffleStringsIfNeeded',
                value: function shuffleStringsIfNeeded() {
                  if (!this.shuffle) return;
                  this.sequence = this.sequence.sort(function () {
                    return Math.random() - 0.5;
                  });
                }
                /**
                 * Adds a CSS class to fade out current string
                 * @private
                 */

              }, {
                key: 'initFadeOut',
                value: function initFadeOut() {
                  var _this5 = this;

                  this.el.className += ' ' + this.fadeOutClass;
                  if (this.cursor) this.cursor.className += ' ' + this.fadeOutClass;
                  return setTimeout(function () {
                    _this5.arrayPos++;

                    _this5.replaceText(''); // Resets current string if end of loop reached


                    if (_this5.strings.length > _this5.arrayPos) {
                      _this5.typewrite(_this5.strings[_this5.sequence[_this5.arrayPos]], 0);
                    } else {
                      _this5.typewrite(_this5.strings[0], 0);

                      _this5.arrayPos = 0;
                    }
                  }, this.fadeOutDelay);
                }
                /**
                 * Replaces current text in the HTML element
                 * depending on element type
                 * @param {string} str
                 * @private
                 */

              }, {
                key: 'replaceText',
                value: function replaceText(str) {
                  if (this.attr) {
                    this.el.setAttribute(this.attr, str);
                  } else {
                    if (this.isInput) {
                      this.el.value = str;
                    } else if (this.contentType === 'html') {
                      this.el.innerHTML = str;
                    } else {
                      this.el.textContent = str;
                    }
                  }
                }
                /**
                 * If using input elements, bind focus in order to
                 * start and stop the animation
                 * @private
                 */

              }, {
                key: 'bindFocusEvents',
                value: function bindFocusEvents() {
                  var _this6 = this;

                  if (!this.isInput) return;
                  this.el.addEventListener('focus', function (e) {
                    _this6.stop();
                  });
                  this.el.addEventListener('blur', function (e) {
                    if (_this6.el.value && _this6.el.value.length !== 0) {
                      return;
                    }

                    _this6.start();
                  });
                }
                /**
                 * On init, insert the cursor element
                 * @private
                 */

              }, {
                key: 'insertCursor',
                value: function insertCursor() {
                  if (!this.showCursor) return;
                  if (this.cursor) return;
                  this.cursor = document.createElement('span');
                  this.cursor.className = 'typed-cursor';
                  this.cursor.innerHTML = this.cursorChar;
                  this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling);
                }
              }]);

              return Typed;
            }();

            exports['default'] = Typed;
            module.exports = exports['default'];
            /***/
          },
          /* 1 */

          /***/
          function (module, exports, __webpack_require__) {
            'use strict';

            Object.defineProperty(exports, '__esModule', {
              value: true
            });

            var _extends = Object.assign || function (target) {
              for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];

                for (var key in source) {
                  if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                  }
                }
              }

              return target;
            };

            var _createClass = function () {
              function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ('value' in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }

              return function (Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
              };
            }();

            function _interopRequireDefault(obj) {
              return obj && obj.__esModule ? obj : {
                'default': obj
              };
            }

            function _classCallCheck(instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
              }
            }

            var _defaultsJs = __webpack_require__(2);

            var _defaultsJs2 = _interopRequireDefault(_defaultsJs);
            /**
             * Initialize the Typed object
             */


            var Initializer = function () {
              function Initializer() {
                _classCallCheck(this, Initializer);
              }

              _createClass(Initializer, [{
                key: 'load',

                /**
                 * Load up defaults & options on the Typed instance
                 * @param {Typed} self instance of Typed
                 * @param {object} options options object
                 * @param {string} elementId HTML element ID _OR_ instance of HTML element
                 * @private
                 */
                value: function load(self, options, elementId) {
                  // chosen element to manipulate text
                  if (typeof elementId === 'string') {
                    self.el = document.querySelector(elementId);
                  } else {
                    self.el = elementId;
                  }

                  self.options = _extends({}, _defaultsJs2['default'], options); // attribute to type into

                  self.isInput = self.el.tagName.toLowerCase() === 'input';
                  self.attr = self.options.attr;
                  self.bindInputFocusEvents = self.options.bindInputFocusEvents; // show cursor

                  self.showCursor = self.isInput ? false : self.options.showCursor; // custom cursor

                  self.cursorChar = self.options.cursorChar; // Is the cursor blinking

                  self.cursorBlinking = true; // text content of element

                  self.elContent = self.attr ? self.el.getAttribute(self.attr) : self.el.textContent; // html or plain text

                  self.contentType = self.options.contentType; // typing speed

                  self.typeSpeed = self.options.typeSpeed; // add a delay before typing starts

                  self.startDelay = self.options.startDelay; // backspacing speed

                  self.backSpeed = self.options.backSpeed; // only backspace what doesn't match the previous string

                  self.smartBackspace = self.options.smartBackspace; // amount of time to wait before backspacing

                  self.backDelay = self.options.backDelay; // Fade out instead of backspace

                  self.fadeOut = self.options.fadeOut;
                  self.fadeOutClass = self.options.fadeOutClass;
                  self.fadeOutDelay = self.options.fadeOutDelay; // variable to check whether typing is currently paused

                  self.isPaused = false; // input strings of text

                  self.strings = self.options.strings.map(function (s) {
                    return s.trim();
                  }); // div containing strings

                  if (typeof self.options.stringsElement === 'string') {
                    self.stringsElement = document.querySelector(self.options.stringsElement);
                  } else {
                    self.stringsElement = self.options.stringsElement;
                  }

                  if (self.stringsElement) {
                    self.strings = [];
                    self.stringsElement.style.display = 'none';
                    var strings = Array.prototype.slice.apply(self.stringsElement.children);
                    var stringsLength = strings.length;

                    if (stringsLength) {
                      for (var i = 0; i < stringsLength; i += 1) {
                        var stringEl = strings[i];
                        self.strings.push(stringEl.innerHTML.trim());
                      }
                    }
                  } // character number position of current string


                  self.strPos = 0; // current array position

                  self.arrayPos = 0; // index of string to stop backspacing on

                  self.stopNum = 0; // Looping logic

                  self.loop = self.options.loop;
                  self.loopCount = self.options.loopCount;
                  self.curLoop = 0; // shuffle the strings

                  self.shuffle = self.options.shuffle; // the order of strings

                  self.sequence = [];
                  self.pause = {
                    status: false,
                    typewrite: true,
                    curString: '',
                    curStrPos: 0
                  }; // When the typing is complete (when not looped)

                  self.typingComplete = false; // Set the order in which the strings are typed

                  for (var i in self.strings) {
                    self.sequence[i] = i;
                  } // If there is some text in the element


                  self.currentElContent = this.getCurrentElContent(self);
                  self.autoInsertCss = self.options.autoInsertCss;
                  this.appendAnimationCss(self);
                }
              }, {
                key: 'getCurrentElContent',
                value: function getCurrentElContent(self) {
                  var elContent = '';

                  if (self.attr) {
                    elContent = self.el.getAttribute(self.attr);
                  } else if (self.isInput) {
                    elContent = self.el.value;
                  } else if (self.contentType === 'html') {
                    elContent = self.el.innerHTML;
                  } else {
                    elContent = self.el.textContent;
                  }

                  return elContent;
                }
              }, {
                key: 'appendAnimationCss',
                value: function appendAnimationCss(self) {
                  if (!self.autoInsertCss) {
                    return;
                  }

                  if (!self.showCursor || !self.fadeOut) {
                    return;
                  }

                  var css = document.createElement('style');
                  css.type = 'text/css';
                  var innerCss = '';

                  if (self.showCursor) {
                    innerCss += '\n        .typed-cursor{\n          opacity: 1;\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      ';
                  }

                  if (self.fadeOut) {
                    innerCss += '\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n          -webkit-animation: 0;\n                  animation: 0;\n        }\n      ';
                  }

                  if (css.length === 0) {
                    return;
                  }

                  css.innerHTML = innerCss;
                  document.head.appendChild(css);
                }
              }]);

              return Initializer;
            }();

            exports['default'] = Initializer;
            var initializer = new Initializer();
            exports.initializer = initializer;
            /***/
          },
          /* 2 */

          /***/
          function (module, exports) {
            /**
             * Defaults & options
             * @returns {object} Typed defaults & options
             * @public
             */
            'use strict';

            Object.defineProperty(exports, '__esModule', {
              value: true
            });
            var defaults = {
              /**
               * @property {array} strings strings to be typed
               * @property {string} stringsElement ID of element containing string children
               */
              strings: ['These are the default values...', 'You know what you should do?', 'Use your own!', 'Have a great day!'],
              stringsElement: null,

              /**
               * @property {number} typeSpeed type speed in milliseconds
               */
              typeSpeed: 0,

              /**
               * @property {number} startDelay time before typing starts in milliseconds
               */
              startDelay: 0,

              /**
               * @property {number} backSpeed backspacing speed in milliseconds
               */
              backSpeed: 0,

              /**
               * @property {boolean} smartBackspace only backspace what doesn't match the previous string
               */
              smartBackspace: true,

              /**
               * @property {boolean} shuffle shuffle the strings
               */
              shuffle: false,

              /**
               * @property {number} backDelay time before backspacing in milliseconds
               */
              backDelay: 700,

              /**
               * @property {boolean} fadeOut Fade out instead of backspace
               * @property {string} fadeOutClass css class for fade animation
               * @property {boolean} fadeOutDelay Fade out delay in milliseconds
               */
              fadeOut: false,
              fadeOutClass: 'typed-fade-out',
              fadeOutDelay: 500,

              /**
               * @property {boolean} loop loop strings
               * @property {number} loopCount amount of loops
               */
              loop: false,
              loopCount: Infinity,

              /**
               * @property {boolean} showCursor show cursor
               * @property {string} cursorChar character for cursor
               * @property {boolean} autoInsertCss insert CSS for cursor and fadeOut into HTML <head>
               */
              showCursor: true,
              cursorChar: '|',
              autoInsertCss: true,

              /**
               * @property {string} attr attribute for typing
               * Ex: input placeholder, value, or just HTML text
               */
              attr: null,

              /**
               * @property {boolean} bindInputFocusEvents bind to focus and blur if el is text input
               */
              bindInputFocusEvents: false,

              /**
               * @property {string} contentType 'html' or 'null' for plaintext
               */
              contentType: 'html',

              /**
               * All typing is complete
               * @param {Typed} self
               */
              onComplete: function onComplete(self) {},

              /**
               * Before each string is typed
               * @param {number} arrayPos
               * @param {Typed} self
               */
              preStringTyped: function preStringTyped(arrayPos, self) {},

              /**
               * After each string is typed
               * @param {number} arrayPos
               * @param {Typed} self
               */
              onStringTyped: function onStringTyped(arrayPos, self) {},

              /**
               * During looping, after last string is typed
               * @param {Typed} self
               */
              onLastStringBackspaced: function onLastStringBackspaced(self) {},

              /**
               * Typing has been stopped
               * @param {number} arrayPos
               * @param {Typed} self
               */
              onTypingPaused: function onTypingPaused(arrayPos, self) {},

              /**
               * Typing has been started after being stopped
               * @param {number} arrayPos
               * @param {Typed} self
               */
              onTypingResumed: function onTypingResumed(arrayPos, self) {},

              /**
               * After reset
               * @param {Typed} self
               */
              onReset: function onReset(self) {},

              /**
               * After stop
               * @param {number} arrayPos
               * @param {Typed} self
               */
              onStop: function onStop(arrayPos, self) {},

              /**
               * After start
               * @param {number} arrayPos
               * @param {Typed} self
               */
              onStart: function onStart(arrayPos, self) {},

              /**
               * After destroy
               * @param {Typed} self
               */
              onDestroy: function onDestroy(self) {}
            };
            exports['default'] = defaults;
            module.exports = exports['default'];
            /***/
          },
          /* 3 */

          /***/
          function (module, exports) {
            /**
             * TODO: These methods can probably be combined somehow
             * Parse HTML tags & HTML Characters
             */
            'use strict';

            Object.defineProperty(exports, '__esModule', {
              value: true
            });

            var _createClass = function () {
              function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ('value' in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }

              return function (Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
              };
            }();

            function _classCallCheck(instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
              }
            }

            var HTMLParser = function () {
              function HTMLParser() {
                _classCallCheck(this, HTMLParser);
              }

              _createClass(HTMLParser, [{
                key: 'typeHtmlChars',

                /**
                 * Type HTML tags & HTML Characters
                 * @param {string} curString Current string
                 * @param {number} curStrPos Position in current string
                 * @param {Typed} self instance of Typed
                 * @returns {number} a new string position
                 * @private
                 */
                value: function typeHtmlChars(curString, curStrPos, self) {
                  if (self.contentType !== 'html') return curStrPos;
                  var curChar = curString.substr(curStrPos).charAt(0);

                  if (curChar === '<' || curChar === '&') {
                    var endTag = '';

                    if (curChar === '<') {
                      endTag = '>';
                    } else {
                      endTag = ';';
                    }

                    while (curString.substr(curStrPos + 1).charAt(0) !== endTag) {
                      curStrPos++;

                      if (curStrPos + 1 > curString.length) {
                        break;
                      }
                    }

                    curStrPos++;
                  }

                  return curStrPos;
                }
                /**
                 * Backspace HTML tags and HTML Characters
                 * @param {string} curString Current string
                 * @param {number} curStrPos Position in current string
                 * @param {Typed} self instance of Typed
                 * @returns {number} a new string position
                 * @private
                 */

              }, {
                key: 'backSpaceHtmlChars',
                value: function backSpaceHtmlChars(curString, curStrPos, self) {
                  if (self.contentType !== 'html') return curStrPos;
                  var curChar = curString.substr(curStrPos).charAt(0);

                  if (curChar === '>' || curChar === ';') {
                    var endTag = '';

                    if (curChar === '>') {
                      endTag = '<';
                    } else {
                      endTag = '&';
                    }

                    while (curString.substr(curStrPos - 1).charAt(0) !== endTag) {
                      curStrPos--;

                      if (curStrPos < 0) {
                        break;
                      }
                    }

                    curStrPos--;
                  }

                  return curStrPos;
                }
              }]);

              return HTMLParser;
            }();

            exports['default'] = HTMLParser;
            var htmlParser = new HTMLParser();
            exports.htmlParser = htmlParser;
            /***/
          }])
        );
      });

      ;
      /***/
    },
    /* 12 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
      /***/
    }])
  );
});